import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import ClassificationsAPI from '../../api/classifications';

const types = {
  SET_CLASSIFICATION_UI_FLAG: 'SET_CLASSIFICATION_UI_FLAG',
  SET_CLASSIFICATIONS: 'SET_CLASSIFICATIONS',
  ADD_CLASSIFICATION: 'ADD_CLASSIFICATION',
  EDIT_CLASSIFICATION: 'EDIT_CLASSIFICATION',
  DELETE_CLASSIFICATION: 'DELETE_CLASSIFICATION',
};

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getClassifications(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getClassificationById: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
  getActiveClassifications(_state) {
    return _state.records
      .filter(record => record.is_active)
      .sort((a, b) => a.name.localeCompare(b.name));
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.SET_CLASSIFICATION_UI_FLAG, { isFetching: true });
    try {
      const response = await ClassificationsAPI.get();
      const records = (response.data.payload || []).sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      commit(types.SET_CLASSIFICATIONS, records);
    } catch (error) {
      // Ignore error for now; caller can inspect uiFlags if needed
    } finally {
      commit(types.SET_CLASSIFICATION_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, payload) {
    commit(types.SET_CLASSIFICATION_UI_FLAG, { isCreating: true });
    try {
      const response = await ClassificationsAPI.create(payload);
      commit(types.ADD_CLASSIFICATION, response.data);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        'Error creating classification';
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_CLASSIFICATION_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { id, ...attrs }) {
    commit(types.SET_CLASSIFICATION_UI_FLAG, { isUpdating: true });
    try {
      const response = await ClassificationsAPI.update(id, attrs);
      commit(types.EDIT_CLASSIFICATION, response.data);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        'Error updating classification';
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_CLASSIFICATION_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit(types.SET_CLASSIFICATION_UI_FLAG, { isDeleting: true });
    try {
      await ClassificationsAPI.delete(id);
      commit(types.DELETE_CLASSIFICATION, id);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        'Error deleting classification';
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_CLASSIFICATION_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CLASSIFICATION_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CLASSIFICATIONS]: MutationHelpers.set,
  [types.ADD_CLASSIFICATION]: MutationHelpers.create,
  [types.EDIT_CLASSIFICATION]: MutationHelpers.update,
  [types.DELETE_CLASSIFICATION]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
